module.exports = "/images/vendor/desiigner-svg/svg/social/apple_podcasts.svg?00692e7f03d862115db48f9e529df27b";